/**
 * @file
 * Scroll reveal. Elements opt in with data-campaign-reveal="up|left|right|fade"
 * and reveal once on entry. The .campaign-reveal-ready class on <html> is what
 * activates the hidden state in CSS, so without JS everything stays visible.
 */
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.campaignReveal = {
    attach: function attach(context) {
      var supported =
        'IntersectionObserver' in window &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var elements = once(
        'campaign-reveal',
        '[data-campaign-reveal]',
        context
      );

      if (!elements.length) {
        return;
      }

      if (!supported) {
        elements.forEach(function (element) {
          element.classList.add('is-revealed');
        });
        return;
      }

      document.documentElement.classList.add('campaign-reveal-ready');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        {
          // Fire slightly before the element is fully on screen.
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.1,
        }
      );

      elements.forEach(function (element) {
        observer.observe(element);
      });
    },
  };
})(Drupal, once);
